import NovalueCheck from './NoValueCheck';

export default (value, age, gender) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;
  var max = 0, min = 0;

  if (age <= 3) {  
    max = 16.8;
    min = 5.1;
  } 
  else if (age <= 13) { 
    max = 16.8;
    min = 7;
  } 
  else if (age <= 19) { 
    max = 21;
    min = 8.4;
  } 
  else if (age <= 50) {
    if (gender == '0') { 
        max = 18.7;
        min = 7;
    } else {
        max = 20.6;
        min = 8.9;
    }
  } 
  else {
    if (gender == '0') {
        max = 20.1;
        min = 9.8;
    } else {
        max = 25.7;
        min = 8.4;
    }
  }

  if(value > max) {
    return { 
      title: 'ค่ามากผิดปกติ',
      color: 'red',
      caption: 'ค่ามากผิดปกติ',
      suggest: ''
    };
  } else if(value < min) {
    return { 
      title: 'ค่าน้อยผิดปกติ',
      color: 'red',
      caption: 'ค่าน้อยผิดปกติ',
      suggest: ''
    };
  } else {
    return { 
      title: 'อยู่ในเกณฑ์ปกติ',
      color: 'green',
      caption: 'อยู่ในเกณฑ์ปกติ',
      suggest: ''
    };
  }
}